export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f9cdc7ba1e6518e7c6c6b2af3af0de1178651c487&name=fetchTypeahead!'